/**
 * Imperative toast bridge for thunks and services (no React hooks).
 * AppToastProvider registers the PrimeReact Toast handler at runtime.
 */

let handler = null;

export function registerAppToastHandler(fn) {
  handler = typeof fn === "function" ? fn : null;
}

/**
 * @param {object} options PrimeReact Toast message: severity, summary, detail, life?, sticky?
 */
export function showAppToast(options) {
  if (!options || typeof options !== "object") return;
  if (handler) {
    handler(options);
    return;
  }
  const detail = options.detail || options.summary || "";
  if (detail) {
    // eslint-disable-next-line no-console
    console.warn("[toast]", options.summary || "", detail);
  }
}
